export const DASHBOARD_CONFIG = {
  // Pagination settings
  DEFAULT_PAGE_SIZE: 12,
  MAX_PAGE_SIZE: 50,
  
  // Loading messages
  MESSAGES: {
    LOADING: {
      EVENTS: 'Loading events...',
      UPCOMING_EVENTS: 'Loading upcoming events...',
      COMMUNITY_ACTIVITY: 'Loading community activity...',
      RECENT_ACTIVITY: 'Loading recent activity...',
      DASHBOARD_DATA: 'Loading dashboard data...'
    },
    NO_DATA: {
      EVENTS: 'No events found',
      UPCOMING_EVENTS: 'No upcoming events',
      COMMUNITY_ACTIVITY: 'No recent community activity to display',
      RECENT_ACTIVITY: 'No recent activity to display',
      CREATE_FIRST_EVENT: 'Create your first event.',
      TRY_ADJUSTING_FILTERS: 'Try adjusting your filters.'
    },
    EMPTY_STATE: {
      UPCOMING_EVENTS: 'Check back later for new events',
      COMMUNITY_ACTIVITY: 'No recent community activity to display'
    }
  },
  
  // Default values for stats
  DEFAULT_STATS: {
    EVENTS_ATTENDED: 0,
    EVENTS_CREATED: 0,
    COMMUNITY_POINTS: 0,
    UPCOMING_EVENTS: 0,
    TOTAL_EVENTS: 0,
    TOTAL_USERS: 0,
    PENDING_APPROVALS: 0,
    ACTIVE_EVENTS: 0
  },
  
  // API limits
  UPCOMING_EVENTS_LIMIT: 10,
  FEATURED_EVENTS_LIMIT: 10,
  
  // Display thresholds
  ATTENDEE_COUNT_THRESHOLD: 1000,
  ATTENDEE_COUNT_SUFFIX: 'k+'
};
